/**
 * City coordinates mapping for US cities
 * Used as fallback when Ticketmaster venue coordinates are not available
 * Maps city names to their latitude/longitude coordinates
 */

export const CITY_COORDINATES = {
  // Format: "City Name": { lat, lng, state }

  // Top 50 US Cities
  'New York': { lat: 40.67, lng: -73.94, state: 'New York' },
  'New York City': { lat: 40.67, lng: -73.94, state: 'New York' },
  NYC: { lat: 40.67, lng: -73.94, state: 'New York' },
  Manhattan: { lat: 40.67, lng: -73.94, state: 'New York' },
  Brooklyn: { lat: 40.67, lng: -73.94, state: 'New York' },

  'Los Angeles': { lat: 34.11, lng: -118.41, state: 'California' },
  LA: { lat: 34.11, lng: -118.41, state: 'California' },

  Chicago: { lat: 41.84, lng: -87.68, state: 'Illinois' },

  Houston: { lat: 29.7407, lng: -95.4636, state: 'Texas' },

  Phoenix: { lat: 33.54, lng: -112.07, state: 'Arizona' },

  Philadelphia: { lat: 40.01, lng: -75.13, state: 'Pennsylvania' },

  'San Antonio': { lat: 29.46, lng: -98.51, state: 'Texas' },

  'San Diego': { lat: 32.81, lng: -117.14, state: 'California' },

  Dallas: { lat: 32.79, lng: -96.77, state: 'Texas' },

  'San Jose': { lat: 37.3, lng: -121.85, state: 'California' },

  Austin: { lat: 30.31, lng: -97.75, state: 'Texas' },

  Jacksonville: { lat: 30.33, lng: -81.66, state: 'Florida' },

  'Fort Worth': { lat: 32.75, lng: -97.34, state: 'Texas' },

  Columbus: { lat: 39.99, lng: -82.99, state: 'Ohio' },

  Charlotte: { lat: 35.2, lng: -80.83, state: 'North Carolina' },

  Indianapolis: { lat: 39.78, lng: -86.15, state: 'Indiana' },

  'San Francisco': { lat: 37.77, lng: -122.45, state: 'California' },

  Seattle: { lat: 47.62, lng: -122.35, state: 'Washington' },

  Denver: { lat: 39.77, lng: -104.87, state: 'Colorado' },

  Washington: { lat: 38.91, lng: -77.02, state: 'District of Columbia' },
  'Washington DC': { lat: 38.91, lng: -77.02, state: 'District of Columbia' },
  DC: { lat: 38.91, lng: -77.02, state: 'District of Columbia' },

  Nashville: { lat: 36.17, lng: -86.78, state: 'Tennessee' },

  'Oklahoma City': { lat: 35.47, lng: -97.51, state: 'Oklahoma' },

  Boston: { lat: 42.34, lng: -71.02, state: 'Massachusetts' },

  'El Paso': { lat: 31.85, lng: -106.44, state: 'Texas' },

  Portland: { lat: 45.54, lng: -122.66, state: 'Oregon' },

  'Las Vegas': { lat: 36.21, lng: -115.22, state: 'Nevada' },

  Memphis: { lat: 35.11, lng: -90.01, state: 'Tennessee' },

  Detroit: { lat: 42.38, lng: -83.1, state: 'Michigan' },

  Baltimore: { lat: 39.3, lng: -76.61, state: 'Maryland' },

  Milwaukee: { lat: 43.06, lng: -87.97, state: 'Wisconsin' },

  Albuquerque: { lat: 35.12, lng: -106.62, state: 'New Mexico' },

  Fresno: { lat: 36.78, lng: -119.79, state: 'California' },

  Tucson: { lat: 32.2, lng: -110.89, state: 'Arizona' },

  Sacramento: { lat: 38.57, lng: -121.47, state: 'California' },

  'Kansas City': { lat: 39.12, lng: -94.55, state: 'Missouri' },

  Mesa: { lat: 33.42, lng: -111.74, state: 'Arizona' },

  Atlanta: { lat: 33.76, lng: -84.42, state: 'Georgia' },

  Omaha: { lat: 41.26, lng: -96.01, state: 'Nebraska' },

  'Colorado Springs': { lat: 38.86, lng: -104.76, state: 'Colorado' },

  Raleigh: { lat: 35.82, lng: -78.66, state: 'North Carolina' },

  'Long Beach': { lat: 33.79, lng: -118.16, state: 'California' },

  'Virginia Beach': { lat: 36.74, lng: -76.04, state: 'Virginia' },

  Miami: { lat: 25.78, lng: -80.21, state: 'Florida' },

  Oakland: { lat: 37.77, lng: -122.22, state: 'California' },

  Minneapolis: { lat: 44.96, lng: -93.27, state: 'Minnesota' },

  Tulsa: { lat: 36.13, lng: -95.92, state: 'Oklahoma' },

  Bakersfield: { lat: 35.36, lng: -119.0, state: 'California' },

  Wichita: { lat: 37.69, lng: -97.34, state: 'Kansas' },

  Arlington: { lat: 32.69, lng: -97.13, state: 'Texas' },

  Aurora: { lat: 39.71, lng: -104.73, state: 'Colorado' },

  // Additional cities
  Tampa: { lat: 27.95, lng: -82.46, state: 'Florida' },
  Anaheim: { lat: 33.84, lng: -117.91, state: 'California' },
  'St. Louis': { lat: 38.63, lng: -90.2, state: 'Missouri' },
  'Saint Louis': { lat: 38.63, lng: -90.2, state: 'Missouri' },
  Riverside: { lat: 33.98, lng: -117.38, state: 'California' },
  'Corpus Christi': { lat: 27.8, lng: -97.4, state: 'Texas' },
  Lexington: { lat: 38.05, lng: -84.5, state: 'Kentucky' },
  Pittsburgh: { lat: 40.44, lng: -79.96, state: 'Pennsylvania' },
  Anchorage: { lat: 61.22, lng: -149.9, state: 'Alaska' },
  Stockton: { lat: 37.96, lng: -121.29, state: 'California' },
  Cincinnati: { lat: 39.1, lng: -84.51, state: 'Ohio' },
  'St. Paul': { lat: 44.95, lng: -93.09, state: 'Minnesota' },
  'Saint Paul': { lat: 44.95, lng: -93.09, state: 'Minnesota' },
  Toledo: { lat: 41.66, lng: -83.58, state: 'Ohio' },
  Newark: { lat: 40.74, lng: -74.17, state: 'New Jersey' },
  Greensboro: { lat: 36.07, lng: -79.79, state: 'North Carolina' },
  Plano: { lat: 33.02, lng: -96.7, state: 'Texas' },
  Henderson: { lat: 36.04, lng: -114.98, state: 'Nevada' },
  Lincoln: { lat: 40.81, lng: -96.68, state: 'Nebraska' },
  Buffalo: { lat: 42.89, lng: -78.88, state: 'New York' },
  'Jersey City': { lat: 40.73, lng: -74.04, state: 'New Jersey' },
  'Chula Vista': { lat: 32.64, lng: -117.08, state: 'California' },
  Orlando: { lat: 28.54, lng: -81.38, state: 'Florida' },
  Norfolk: { lat: 36.85, lng: -76.29, state: 'Virginia' },
  Chandler: { lat: 33.31, lng: -111.84, state: 'Arizona' },
  Laredo: { lat: 27.51, lng: -99.51, state: 'Texas' },
  Madison: { lat: 43.07, lng: -89.4, state: 'Wisconsin' },
  Durham: { lat: 35.99, lng: -78.9, state: 'North Carolina' },
  Lubbock: { lat: 33.58, lng: -101.86, state: 'Texas' },
  'Winston-Salem': { lat: 36.1, lng: -80.24, state: 'North Carolina' },
  Garland: { lat: 32.91, lng: -96.64, state: 'Texas' },
  Glendale: { lat: 33.54, lng: -112.19, state: 'Arizona' },
  Hialeah: { lat: 25.86, lng: -80.28, state: 'Florida' },
  Reno: { lat: 39.53, lng: -119.81, state: 'Nevada' },
  'Baton Rouge': { lat: 30.45, lng: -91.19, state: 'Louisiana' },
  Irving: { lat: 32.81, lng: -96.95, state: 'Texas' },
  Scottsdale: { lat: 33.5, lng: -111.9, state: 'Arizona' },
  Richmond: { lat: 37.54, lng: -77.46, state: 'Virginia' },
  Spokane: { lat: 47.66, lng: -117.43, state: 'Washington' },
  Gilbert: { lat: 33.35, lng: -111.79, state: 'Arizona' },
  Fremont: { lat: 37.55, lng: -121.99, state: 'California' },
  Medford: { lat: 42.33, lng: -122.88, state: 'Oregon' },
  Cambridge: { lat: 42.37, lng: -71.11, state: 'Massachusetts' },
  Somerville: { lat: 42.39, lng: -71.1, state: 'Massachusetts' },
  'West Hollywood': { lat: 34.09, lng: -118.36, state: 'California' },
  Hollywood: { lat: 34.1, lng: -118.33, state: 'California' },
};

/**
 * US State center coordinates
 * Used as fallback when city is not found
 */
export const STATE_COORDINATES = {
  Alabama: { lat: 32.806671, lng: -86.79113 },
  AL: { lat: 32.806671, lng: -86.79113 },
  Alaska: { lat: 61.370716, lng: -152.404419 },
  AK: { lat: 61.370716, lng: -152.404419 },
  Arizona: { lat: 33.729759, lng: -111.431221 },
  AZ: { lat: 33.729759, lng: -111.431221 },
  Arkansas: { lat: 34.969704, lng: -92.373123 },
  AR: { lat: 34.969704, lng: -92.373123 },
  California: { lat: 36.116203, lng: -119.681564 },
  CA: { lat: 36.116203, lng: -119.681564 },
  Colorado: { lat: 39.059811, lng: -105.311104 },
  CO: { lat: 39.059811, lng: -105.311104 },
  Connecticut: { lat: 41.597782, lng: -72.755371 },
  CT: { lat: 41.597782, lng: -72.755371 },
  Delaware: { lat: 39.318523, lng: -75.507141 },
  DE: { lat: 39.318523, lng: -75.507141 },
  Florida: { lat: 27.766279, lng: -81.686783 },
  FL: { lat: 27.766279, lng: -81.686783 },
  Georgia: { lat: 33.040619, lng: -83.643074 },
  GA: { lat: 33.040619, lng: -83.643074 },
  Hawaii: { lat: 21.094318, lng: -157.498337 },
  HI: { lat: 21.094318, lng: -157.498337 },
  Idaho: { lat: 44.240459, lng: -114.478828 },
  ID: { lat: 44.240459, lng: -114.478828 },
  Illinois: { lat: 40.349457, lng: -88.986137 },
  IL: { lat: 40.349457, lng: -88.986137 },
  Indiana: { lat: 39.849426, lng: -86.258278 },
  IN: { lat: 39.849426, lng: -86.258278 },
  Iowa: { lat: 42.011539, lng: -93.210526 },
  IA: { lat: 42.011539, lng: -93.210526 },
  Kansas: { lat: 38.5266, lng: -96.726486 },
  KS: { lat: 38.5266, lng: -96.726486 },
  Kentucky: { lat: 37.66814, lng: -84.670067 },
  KY: { lat: 37.66814, lng: -84.670067 },
  Louisiana: { lat: 31.169546, lng: -91.867805 },
  LA: { lat: 31.169546, lng: -91.867805 },
  Maine: { lat: 44.693947, lng: -69.381927 },
  ME: { lat: 44.693947, lng: -69.381927 },
  Maryland: { lat: 39.063946, lng: -76.802101 },
  MD: { lat: 39.063946, lng: -76.802101 },
  Massachusetts: { lat: 42.230171, lng: -71.530106 },
  MA: { lat: 42.230171, lng: -71.530106 },
  Michigan: { lat: 43.326618, lng: -84.536095 },
  MI: { lat: 43.326618, lng: -84.536095 },
  Minnesota: { lat: 45.694454, lng: -93.900192 },
  MN: { lat: 45.694454, lng: -93.900192 },
  Mississippi: { lat: 32.741646, lng: -89.678696 },
  MS: { lat: 32.741646, lng: -89.678696 },
  Missouri: { lat: 38.456085, lng: -92.288368 },
  MO: { lat: 38.456085, lng: -92.288368 },
  Montana: { lat: 46.921925, lng: -110.454353 },
  MT: { lat: 46.921925, lng: -110.454353 },
  Nebraska: { lat: 41.12537, lng: -98.268082 },
  NE: { lat: 41.12537, lng: -98.268082 },
  Nevada: { lat: 38.313515, lng: -117.055374 },
  NV: { lat: 38.313515, lng: -117.055374 },
  'New Hampshire': { lat: 43.452492, lng: -71.563896 },
  NH: { lat: 43.452492, lng: -71.563896 },
  'New Jersey': { lat: 40.298904, lng: -74.521011 },
  NJ: { lat: 40.298904, lng: -74.521011 },
  'New Mexico': { lat: 34.840515, lng: -106.248482 },
  NM: { lat: 34.840515, lng: -106.248482 },
  'New York': { lat: 42.165726, lng: -74.948051 },
  NY: { lat: 42.165726, lng: -74.948051 },
  'North Carolina': { lat: 35.630066, lng: -79.806419 },
  NC: { lat: 35.630066, lng: -79.806419 },
  'North Dakota': { lat: 47.528912, lng: -99.784012 },
  ND: { lat: 47.528912, lng: -99.784012 },
  Ohio: { lat: 40.388783, lng: -82.764915 },
  OH: { lat: 40.388783, lng: -82.764915 },
  Oklahoma: { lat: 35.565342, lng: -96.928917 },
  OK: { lat: 35.565342, lng: -96.928917 },
  Oregon: { lat: 44.572021, lng: -122.070938 },
  OR: { lat: 44.572021, lng: -122.070938 },
  Pennsylvania: { lat: 40.590752, lng: -77.209755 },
  PA: { lat: 40.590752, lng: -77.209755 },
  'Rhode Island': { lat: 41.680893, lng: -71.51178 },
  RI: { lat: 41.680893, lng: -71.51178 },
  'South Carolina': { lat: 33.856892, lng: -80.945007 },
  SC: { lat: 33.856892, lng: -80.945007 },
  'South Dakota': { lat: 44.299782, lng: -99.438828 },
  SD: { lat: 44.299782, lng: -99.438828 },
  Tennessee: { lat: 35.747845, lng: -86.692345 },
  TN: { lat: 35.747845, lng: -86.692345 },
  Texas: { lat: 31.054487, lng: -97.563461 },
  TX: { lat: 31.054487, lng: -97.563461 },
  Utah: { lat: 40.150032, lng: -111.862434 },
  UT: { lat: 40.150032, lng: -111.862434 },
  Vermont: { lat: 44.045876, lng: -72.710686 },
  VT: { lat: 44.045876, lng: -72.710686 },
  Virginia: { lat: 37.769337, lng: -78.169968 },
  VA: { lat: 37.769337, lng: -78.169968 },
  Washington: { lat: 47.400902, lng: -121.490494 },
  WA: { lat: 47.400902, lng: -121.490494 },
  'West Virginia': { lat: 38.491226, lng: -80.954453 },
  WV: { lat: 38.491226, lng: -80.954453 },
  Wisconsin: { lat: 44.268543, lng: -89.616508 },
  WI: { lat: 44.268543, lng: -89.616508 },
  Wyoming: { lat: 42.755966, lng: -107.30249 },
  WY: { lat: 42.755966, lng: -107.30249 },
  'District of Columbia': { lat: 38.91, lng: -77.02 },
  DC: { lat: 38.91, lng: -77.02 },
};

/**
 * Get coordinates for a city name
 * Performs case-insensitive lookup with partial matching
 *
 * @param {string} cityName - City name from Ticketmaster
 * @param {string} stateName - Optional state name for disambiguation
 * @returns {Object|null} {lat, lng} or null if not found
 */
export const getCityCoordinates = (cityName, stateName = null) => {
  if (!cityName) {
    return null;
  }

  const normalizedCity = cityName.trim();

  // Try exact match first (case-insensitive)
  const exactMatch = Object.keys(CITY_COORDINATES).find(
    key => key.toLowerCase() === normalizedCity.toLowerCase()
  );

  if (exactMatch) {
    const coords = CITY_COORDINATES[exactMatch];
    // If state provided, verify it matches
    if (stateName && coords.state.toLowerCase() !== stateName.toLowerCase()) {
      console.warn(`City ${cityName} found but state mismatch: ${stateName} vs ${coords.state}`);
    }
    return { lat: coords.lat, lng: coords.lng };
  }

  // Try partial match (e.g., "West Hollywood" matches "Los Angeles")
  const partialMatch = Object.keys(CITY_COORDINATES).find(
    key =>
      normalizedCity.toLowerCase().includes(key.toLowerCase()) ||
      key.toLowerCase().includes(normalizedCity.toLowerCase())
  );

  if (partialMatch) {
    const coords = CITY_COORDINATES[partialMatch];
    return { lat: coords.lat, lng: coords.lng };
  }

  return null;
};

/**
 * Extract city coordinates from venue data
 * Uses venue.location coordinates if available, otherwise falls back to city mapping
 *
 * @param {Object} venue - Venue object from Ticketmaster
 * @returns {Object|null} {lat, lng} or null
 */
export const getVenueCoordinates = venue => {
  if (!venue) {
    return null;
  }

  // First try direct coordinates from venue.location
  if (venue.location?.latitude && venue.location?.longitude) {
    return {
      lat: parseFloat(venue.location.latitude),
      lng: parseFloat(venue.location.longitude),
    };
  }

  // Second try flat latitude/longitude properties
  if (venue.latitude && venue.longitude) {
    return {
      lat: parseFloat(venue.latitude),
      lng: parseFloat(venue.longitude),
    };
  }

  // Fallback to city mapping
  const cityName = venue.city?.name || venue.city;
  const stateName = venue.state?.name || venue.state;

  if (cityName) {
    const coords = getCityCoordinates(cityName, stateName);
    if (coords) {
      return coords;
    }
  }

  return null;
};

export default {
  CITY_COORDINATES,
  getCityCoordinates,
  getVenueCoordinates,
};
